import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslator } from '@gandi/translate';
import { Base, Button } from '@gandi/ui';
import { setCartWidgetVisibility } from '../../../../modules/widget/actions';
import { selectCartWidgetShowPrices } from '../../../../modules/widget/selectors';
import CartContentContext from '../../CartContentContext';
import PricesFor from './PricesFor';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function PricesIndicator() {
  const {
    __
  } = useTranslator();
  const dispatch = useDispatch();
  const prices = useSelector(selectCartWidgetShowPrices);
  const {
    openPreferences
  } = React.useContext(CartContentContext);
  const hideCartWidget = () => {
    dispatch(setCartWidgetVisibility(false));
  };
  return /*#__PURE__*/_jsxs(Base, {
    size: "small",
    color: "light",
    children: [/*#__PURE__*/_jsx(PricesFor, {}), prices && openPreferences && /*#__PURE__*/_jsxs(_Fragment, {
      children: [' ', /*#__PURE__*/_jsx(Button, {
        kind: "link",
        onClick: () => {
          hideCartWidget();
          openPreferences();
        },
        children: __('Change')
      })]
    })]
  });
}